import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NbDialogService, NbStepChangeEvent, NbStepperComponent } from '@nebular/theme';
import { ContentEnum, GridCell, GridCellClass, GridOptions, HeaderFooterPosition, OrientationEnum } from '@urbannex/storethemes';
import { GridInputDialogComponent } from '../grid-input-dialog/grid-input-dialog.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
//import * as imageData from './imageDirTree.json';

@Component({
  selector: 'kve-add-grid',
  templateUrl: './add-grid.component.html',
  styleUrls: ['./add-grid.component.scss']
})
export class AddGridComponent implements OnInit {
  title:string = "Add New Grid";
  toolTip:string = "Color range used for general elements such as backgrounds, buttons and text.You can override this for specific elements.";
  cells:number[] = [2,3,4,5,6,7,8,9];

  linearMode = true;

  gridNameForm = new FormGroup({
    gridName: new FormControl('',Validators.required),
  });
  gridLayoutForm = new FormGroup({
    gridLayout: new FormControl('',Validators.required),
  }); 

  data3 = {numberOfElements:3}
  data4 = {numberOfElements:4}
  data5 = {numberOfElements:5}
  data6 = {numberOfElements:6}
  data7 = {numberOfElements:7}
  data8 = {numberOfElements:8}
  data9 = {numberOfElements:9}
  defaultData:any[] = [];

  @ViewChild("stepper") stepper: NbStepperComponent;

  @ViewChild('2cell', {read: ElementRef}) twoCell: ElementRef;
  @ViewChild('3cell', {read: ElementRef}) threeCell: ElementRef;
  @ViewChild('4cell', {read: ElementRef}) fourCell: ElementRef;
  @ViewChild('5cell', {read: ElementRef}) fiveCell: ElementRef;
  @ViewChild('6cell', {read: ElementRef}) sixCell: ElementRef;
  @ViewChild('7cell', {read: ElementRef}) sevenCell: ElementRef;
  @ViewChild('8cell', {read: ElementRef}) eightCell: ElementRef;
  @ViewChild('9cell', {read: ElementRef}) nineCell: ElementRef;


  selectedTemplate:number;
  selectedGridLayout:GridOptions;
  selectedCell:GridCell;// = {imageOrientation:OrientationEnum.PORTRAIT,className:GridCellClass.A}
  isSelected = false;

  public readonly contentEnums : typeof ContentEnum = ContentEnum;

  constructor(private dialogService: NbDialogService) { }

  ngOnInit(): void {
    let grid1:GridOptions = {
      numberOfElements:2,
      hasFlipElements:false,
      variableImageSizes:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        }
      ]
    }
    this.defaultData.push(grid1);
    let grid2:GridOptions = {
      numberOfElements:3,
      hasFlipElements:false,
      variableImageSizes:false,
      largeImageOrientation:OrientationEnum.PORTRAIT,
      headerPosition:HeaderFooterPosition.INSIDE,
      footerPosition:HeaderFooterPosition.INSIDE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.PORTRAIT,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.PORTRAIT,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.PORTRAIT,
          className:GridCellClass.C
        }
      ]
    }
    this.defaultData.push(grid2);
    let grid3:GridOptions = {
      numberOfElements:4,
      hasFlipElements:false,
      variableImageSizes:false,
      largeImageOrientation:OrientationEnum.PORTRAIT,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        }
      ]
    }
    this.defaultData.push(grid3);
    let grid4:GridOptions = {
      numberOfElements:5,
      variableImageSizes:true,
      hasFlipElements:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.E
        }
        
      ]
    }
    this.defaultData.push(grid4);
    let grid5:GridOptions = {
      numberOfElements:6,
      variableImageSizes:true,
      hasFlipElements:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.PORTRAIT,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.E
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.F
        }
      ]
    }
    this.defaultData.push(grid5);
    let grid6:GridOptions = {
      numberOfElements:7,
      variableImageSizes:true,
      hasFlipElements:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.E
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.F
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.G
        }
      ]
    }
    this.defaultData.push(grid6);
    let grid7:GridOptions = {
      numberOfElements:8,
      variableImageSizes:true,
      hasFlipElements:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.E
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.F
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.G
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.H
        }
      ]
    }
    this.defaultData.push(grid7);
    let grid8:GridOptions = {
      numberOfElements:9,
      variableImageSizes:true,
      hasFlipElements:false,
      largeImageOrientation:OrientationEnum.LANDSCAPE,
      headerPosition:HeaderFooterPosition.NONE,
      footerPosition:HeaderFooterPosition.NONE,
      gridCells:[
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.A
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.B
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.C
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.D
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.E
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.F
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.G
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.H
        },
        {
          imageOrientation:OrientationEnum.LANDSCAPE,
          className:GridCellClass.I
        }
      ]
      
    }
    this.defaultData.push(grid8);
  }
  handleStepChange(e: NbStepChangeEvent): void {
    
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    
  }

  getGridOptions(e){
    console.log(e)
  }

  selectGridLayout(selectedLayout:GridOptions){
    console.log(selectedLayout);
    this.selectedGridLayout = selectedLayout;
    this.selectedTemplate = selectedLayout.numberOfElements;
    let host:HTMLElement;
    switch (selectedLayout.numberOfElements) {
      case 2:
        host = this.twoCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-2");
        break;
      case 3:
        host = this.threeCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-3");
        break;
      case 4:
        host = this.fourCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-4");
        break;
      case 5:
        host = this.fiveCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-5");
        break;
      case 6:
        host = this.sixCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-6");
        break;
      case 7:
        host = this.sevenCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-7");
        break;
      case 8:
        host = this.eightCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-8");
        break;
      case 9:
        host = this.nineCell.nativeElement;
        this.gridLayoutForm.controls.gridLayout.setValue("grid-9");
        break;
    
      default:
        break;
    }
    console.log(host);
  }

  selectGridCell(className:string){
    console.log({SelectedGridLayout:this.selectedGridLayout,className:className});
    this.selectedCell = this.selectedGridLayout.gridCells.find(gridCell => gridCell.className == className);
    if(this.selectedCell != null){
      this.isSelected = true;
      console.log({SelectedCell:this.selectedCell});
    }
  }

  open(contentEnum) {
    console.log(contentEnum,this.selectedCell);
    this.dialogService.open(GridInputDialogComponent, {
      context: {
        title: 'This is a title passed to the dialog component',
        contentType:contentEnum,
        selectedCell:this.selectedCell
      },
    });
  }

  setStepComplete(){

  }

  onSubmitName(){
    //console.log(this.gridNameForm.value);
    this.stepper.next();
  }

  onSubmitLayout(){
    this.stepper.next()
  }
}
